import React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import "./App.scss";
// import { MainPage } from "./containers/cases/MainPage";
// import { DocsPage } from "./containers/api/DocsPage";
import routes from "./routes";

const router = createHashRouter(routes);

export default class App extends React.PureComponent {
  render() {
    return (
      <div className="App height-100">
        {/* <HashRouter>
          <div className="height-100">
            <Routes>
              <Route
                path="/"
                element={<Navigate replace to="/docs/introduce" />}
              />
              <Route path="/components" element={<MainPage />} />
              <Route path="/docs" element={<DocsPage />} />
            </Routes>
          </div>
        </HashRouter> */}
        <RouterProvider router={router} />
      </div>
    );
  }
}
